import {panel, absCenter, absFill, colors} from '@xpertdox_js/xdstyle';

export default {
  container: {
    padding: '8px',
    // borderRadius: '4px',
    height: '215px',
    maxHeight: '215px',
    position: 'relative',
    width: '25%',
    display: 'inline-block',
    verticalAlign: 'top',
    padding: '8px',
  },
  addContainer: {
    background: 'none',
    boxShadow: 0,
  },
  blockContent: {
    ...panel,
    padding: 0,
    position: 'relative',
    width: '100%',
    height: '100%',
    marginBottom: 0,
  },
  addButton: {
    border: '2px solid',
    borderColor: colors.darkGray,
    borderRadius: '4px',
    width: '100%',
    height: '100%',
    display: 'block',
    fill: colors.darkGray,
    padding: 0,
    background: 'none',
  },
  addButtonHov: {
    fill: colors.xdHighlight,
    borderColor: colors.xdHighlight,
  },
  addSvg: {
    ...absCenter,
    width: '60px',
    height: '60px',
    display: 'block'
  },
  text: {
    margin: 0,
    fontSize: '1.2rem',
    padding: '4px'
  },
  textContainer: {
    overflow: 'hidden',
    width: '100%',
    height: '49px',
    whiteSpace: 'nowrap'
  },
  stagingImage: {
    container: {
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
      height: '150px',
      width: '100%',
      boxShadow: 0,
      borderTop: '1px solid rgba(0,0,0,0.12)',
      overflow: 'hidden',
    }
  },
  nonUploadImageContainer: {
    position: 'relative',
    width: '100%',
    height: '150px',
    borderTop: '1px solid rgba(0,0,0,0.12)',
    overflow: 'hidden'
  },
  nonUploadImage: {
    container: {
      ...absCenter,
      width: '90%',
    }
  },
  removeBtn: {
    position: 'absolute',
    top: 0,
    left: 'auto', right: 0, bottom: 'auto',
    borderRadius: '100px',
    background: '#fff',
    fill: colors.error,
    padding: 0,
    width: '26px',
    height: '26px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.24)',
    zIndex: 4,
  },
  removeBtnHov: {
    background: colors.error,
    fill: '#fff',
  },
  removeSvg: {
    ...absCenter,
    display: 'block',
    width: '24px',
    height: '24px'
  }
}
